import axiosInstance from '../../../../config/axiosInstance';
const  ContractRateService = {
    async GetAllContractRates(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetContractRates?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteContractRate(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteContract?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default ContractRateService;